import React from "react";
import { useHistory } from "react-router-dom";
import { BRIEF_CHIP, RUN_STATE } from "../../_config/quarterlyOkrConfig";
import { briefRoute } from "../../_config/quarterlyOkrRoutes";
import { formatMeetingDateTime } from "../../../../../utils/meetingDateTime";
import "../../_shared/QokrPrimitives/_qokr-pill.scss";

// The flags a coach scans a quarter for (§9.1): needs review, not completed,
// and the booked live review. Plus the coach brief's status (handoff 34) —
// a link to the brief in every state, so it stays one click away after the
// dashboard button has moved on to the review, live review or scorecard.
const QuarterFlags = ({ quarter }) => {
  const history = useHistory();
  // Not while the review is in progress (2026-10-23, by instruction): the
  // row's button is "Continue review" then, and the brief stays one click
  // away from the review's breadcrumb and Back.
  const brief =
    quarter.run_state === RUN_STATE.COACH_REVIEW_IN_PROGRESS
      ? null
      : BRIEF_CHIP[quarter.brief_status];
  const meeting = quarter.locked_at
    ? null
    : formatMeetingDateTime(quarter.meeting_datetime, "h:mm A [on] D MMM YYYY");

  return (
    <>
      {quarter.needs_review ? (
        <span className="qokr-pill qokr-pill--amber">Needs review</span>
      ) : null}
      {quarter.not_completed ? (
        <span className="qokr-pill qokr-pill--grey">Not completed</span>
      ) : null}
      {brief ? (
        <button
          type="button"
          className={`qokr-pill qokr-pill--${brief.tone} qokr-pill--link`}
          onClick={(event) => {
            event.stopPropagation();
            history.push(briefRoute(quarter.quarter_company_id));
          }}
        >
          <i className="fa-regular fa-file-lines" aria-hidden="true" />
          {brief.label}
        </button>
      ) : null}
      {meeting ? (
        <span className="qokr-pill qokr-pill--teal">Live review {meeting}</span>
      ) : null}
    </>
  );
};

export default QuarterFlags;
